module.exports = __webpack_public_path__ + "img/frame 82.da81777f.png";